import { Box, Typography, useTheme } from '@mui/material'
import { TeamMemberCard } from './TeamMemberCard'
import data from '../../data/data.json'

export function TeamTab() {
  const theme = useTheme()
  
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            fontSize: { xs: '2rem', sm: '2.5rem' },
            background: theme.palette.mode === 'dark' 
              ? 'linear-gradient(135deg, #40d6bd 0%, #1cbc98 100%)' 
              : 'linear-gradient(135deg, #2a7d2a 0%, #0f4d0f 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.02em',
          }}
        >
          The Team
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          {data.project.name} - {data.team.length} engineers - 11 months
        </Typography>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 2 }}>
        {data.team.map((member) => (
          <TeamMemberCard key={member.id} member={member} />
        ))}
      </Box>
    </Box>
  )
}
